import { StorageService } from './storage.service';
import * as i0 from "@angular/core";
import * as i1 from "./storage.service";
var LocalService = /** @class */ (function () {
    function LocalService(storageService) {
        this.storageService = storageService;
    }
    // Set the json data to local
    LocalService.prototype.setJsonValue = function (key, value) {
        this.storageService.secureStorage.setItem(key, value);
    };
    // Get the json value from local
    LocalService.prototype.getJsonValue = function (key) {
        return this.storageService.secureStorage.getItem(key);
    };
    // Remove the json value from local
    LocalService.prototype.removeJsonValue = function (key) {
        return this.storageService.secureStorage.removeItem(key);
    };
    // Clear the local
    LocalService.prototype.clearToken = function () {
        return this.storageService.secureStorage.clear();
    };
    LocalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocalService_Factory() { return new LocalService(i0.ɵɵinject(i1.StorageService)); }, token: LocalService, providedIn: "root" });
    return LocalService;
}());
export { LocalService };
